import Repository from '@/services/Repository';

const resource = '/grades';

export default {
  fetch({ classroom, schoolYear }) {
    let params = { classroom, schoolYear };
    return Repository.get(`${resource}/`, { params });
  },
  fetchByStudent({ student, schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/students/${student}`, { params });
  },
  post(newContent) {
    return Repository.post(`${resource}/`, newContent);
  },
  //   update(content) {
  //     return Repository.put(`${resource}/${content.recordId}`, content.data);
  //   },
  //   delete(contentId) {
  //     return Repository.delete(`${resource}/${contentId}`);
  //   },
};
